import React from 'react'
import { DetailViewWrapper } from '~/components/compositional/CommonWrappers'
import {
  Content,
  Details,
  SubHeading,
} from '~/components/compositional/DetailViewStyles'
import { Text } from '~/components/core'
import { FontStyle } from '~/components/core/Text'
import { PdfViewer } from '~/components/Pdfs/PdfViewer'
import { light } from '~/constants/theme'

import { useFaxPageQueryParams } from './FaxPage'

interface FaxDetailHeaderProps {
  name: string
  timestamp: string
  selectedVirtualFaxName?: string
}
export const FaxDetailHeader = ({
  name,
  timestamp,
  selectedVirtualFaxName,
}: FaxDetailHeaderProps) => {
  return (
    <Details>
      <Text
        fontStyle={FontStyle.MediumBold}
        text={name}
        color={light.dark900}
      />
      <SubHeading>
        <Text
          fontStyle={FontStyle.Small}
          text={timestamp}
          color={light.dark800}
        />
        <Text
          style={{ marginLeft: '4px' }}
          fontStyle={FontStyle.bSmall}
          text={selectedVirtualFaxName ?? ''}
          color={light.dark700}
        />
      </SubHeading>
    </Details>
  )
}

interface FaxDetailViewProps {
  fileUrl: string
  fileName: string
  onFaxPdfLoaded?: (numPages: number) => void
  onPageChange?: (pageNumber: number) => void
}
export const FaxDetailView = ({
  fileUrl,
  fileName,
  onFaxPdfLoaded,
  onPageChange,
}: FaxDetailViewProps) => {
  const { page } = useFaxPageQueryParams()
  return (
    <DetailViewWrapper>
      <Content>
        <PdfViewer
          file={fileUrl}
          filename={fileName}
          pageNumber={page}
          onFaxPdfLoaded={onFaxPdfLoaded}
          onPageChange={onPageChange}
        />
      </Content>
    </DetailViewWrapper>
  )
}
